import {Button} from '@material-ui/core';
import styled from 'styled-components';

import {breakpoint, colors} from 'theme';

export const ControlsWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    @media (min-width: ${breakpoint.phone}) {
        justify-content: flex-start;
        width: auto;
    }
`;

export const AffixingTypeButton = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;
    justify-content: center;
    padding: 20px;
    border-radius: 10px;
    border: 1px solid ${colors.brandLight};
    min-height: 120px;
    transition: border-color ease-in-out 0.15s;
    cursor: pointer;

    :hover {
        border-color: ${colors.brandDark};
    }

    & > img {
        width: 51px;
        height: auto;
    }
`;

export const AffixingTypesWrapper = styled.div`
    display: flex;
    justify-content: center;
    gap: 10px;

    & > * {
        width: 100%;
    }
`;
